import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-text">FalconDev</span>
              <span className="logo-team">Team</span>
            </div>
            <p className="footer-description">
              Crafting epic gaming experiences with passion, innovation, and dedication.
              Join us on our journey to create the future of gaming.
            </p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/storm-dash">Storm Dash</Link></li>
              <li><a href="https://discord.gg/NuB3s65E" target="_blank" rel="noopener noreferrer">Discord</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Our Game</h3>
            <ul className="footer-links">
              <li><Link to="/storm-dash">Storm Dash</Link></li>
              <li><a href="#features">Features</a></li>
              <li><a href="#development">Development</a></li>
              <li><a href="#updates">Updates</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Connect With Us</h3>
            <div className="social-links">
              <a href="https://www.tiktok.com/@falcondevteam" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
                <span>TikTok</span>
              </a>
              <a href="https://www.youtube.com/@FalconDevTeam" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span>YouTube</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 FalconDevTeam. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="https://discord.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              <a href="https://discord.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
            </div>
          </div>
          <div className="footer-credit">
            <p>Designed and Powered by <a href="https://amaandildar.onrender.com/" target="_blank" rel="noopener noreferrer">кяуρтιк</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
